import { Stack, TextField } from "@mui/material"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { BoundTextEditor } from "minimals-template/components/editor"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { useSkills } from "routes/@lib/skills"
import { Repeat } from "lib/@components/repeat"
import { SimpleMenuItem } from "./simple-menu-item"
import { SkillMenuItem } from "./skill-menu-item"

const CLASSIFICATIONS = ["Red", "Amber", "Green"]

const PERIODS = ["Hour", "Day", "Week", "Month", "Year"]

export function ProposedTaskEditForm() {
    const [period, setPeriod] = useBoundValue("frequency.period")
    const [classification, setClassification] = useBoundValue("classification")
    const [skillSet, setSkillSet] = useBoundValue("skillSet")
    const [skillsIndex] = useSkills()
    const skillOptions = Object.values(skillsIndex ?? {})

    return (
        <Stack spacing={2} sx={{ pt: 1 }}>
            <BoundTextField field="title" label="Title" size="small" fullWidth />

            <Stack direction="row" spacing={1.5}>
                <TextField
                    select
                    label="Classification"
                    size="small"
                    value={classification ?? "Amber"}
                    onChange={(e) => setClassification(e.target.value)}
                    sx={{ minWidth: 130 }}
                >
                    <Repeat list={CLASSIFICATIONS} item={<SimpleMenuItem />} />
                </TextField>

                <BoundTextField
                    field="minutes"
                    label="Minutes"
                    size="small"
                    type="number"
                    sx={{ width: 90 }}
                    inputProps={{ min: 0, max: 9999 }}
                />

                <BoundTextField
                    field="frequency.interval"
                    label="Every"
                    size="small"
                    type="number"
                    sx={{ width: 80 }}
                    inputProps={{ min: 1, max: 1200 }}
                />

                <TextField
                    select
                    label="Period"
                    size="small"
                    value={period ?? "Month"}
                    onChange={(e) => setPeriod(e.target.value)}
                    sx={{ minWidth: 100 }}
                >
                    <Repeat list={PERIODS} item={<SimpleMenuItem />} />
                </TextField>

                <TextField
                    select
                    label="Skill Set"
                    size="small"
                    value={skillSet ?? ""}
                    onChange={(e) => setSkillSet(e.target.value)}
                    sx={{ flex: 1, minWidth: 120 }}
                >
                    <Repeat list={skillOptions} item={<SkillMenuItem />} />
                </TextField>
            </Stack>

            <BoundTextEditor field="content" label="Content" />
            <BoundTextEditor field="note" label="Notes" />
        </Stack>
    )
}
